import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {
  namespaced: true,

  actions: {

    async getOrders({state, commit}, param) {
      let length = param.page_length || 5;
      let last_index = param.last_index || state.last_index;

      if (typeof last_index === 'undefined') last_index = 0;

      let url;
      if (!_.isEmpty(param.search)) {
        url = `/order?search=${param.search}` ;
      } else {
        url = `/order?count=${length}&lastidx=${last_index}`;
      }

      if (last_index === 0) {
        commit('RESET_ORDERS');
      }

      try {
        let res = await axios.get(url);
        commit('UPDATE_ORDERS', res.data.data.orders);
        commit('UPDATE_LAST_INDEX', res.data.data.last_index);
        let can_load_more = res.data.data.orders.length === length;
        commit('SET_CAN_LOAD_MORE', can_load_more);
      } catch(e) {
        commit('SET_CAN_LOAD_MORE', false);
        throw e;
      }
    },

    async getNewOrderCount({state, commit}, param) {

    },

    async getOrder({state, commit}, order_id) {
      if (!order_id.toString().match(/^QS\-[a-zA-Z0-9]+$/)) {
        throw "Invalid Order ID";
      }

      try {
        let res = await axios.get(`/order/${order_id}`);
        commit('SET_CURRENT_ORDER', res.data.data);
      } catch(e) {
        throw e;
      }
    },

    async createOrder( {commit}, payload ) {
      try {
        let res = await axios.post('/order', payload);
        commit('UPDATE_ORDER', res.data.data);
      } catch (e) {
        throw e;
      }
    },

    async updateOrder( {commit}, payload ) {
      try {
        payload.order_id = payload.id;
        let res = await axios.patch('/order', payload);
        commit('UPDATE_ORDER', res.data.data);
      } catch (e) {
        throw e;
      }
    },

    async updateFulfillment( {commit}, {order, fulfillment} ) {
      console.dir(order)
      let now = new Date();
      let data = {
        "id": order.order_fulfillment_id,
        "order_id": order.id,
        "organization_fullfillment_provider_id": fulfillment.provider.id,
        "courier_name": fulfillment.courier.name, 
        "tracking_url": fulfillment.url,
        "awb": fulfillment.awb,
        "date": now,
        "user_id": order.user_id,
      }

      try {
        let res = await axios.put(`/order/${data.order_id}/fulfillment`, data);
        commit('UPDATE_FULFILLMENT', {order, fulfillment: res.data.data});
        return res.data.data;
      } catch(e) {
        console.log(e);
        throw(e);
      }
    },

    async complete_payment( {commit}, payload ) {
      try {
        let res = await axios.post(`/order/${payload.order_id}/complete`, payload);
        return res.data;
      } catch (e) {
        throw e;
      }
    },
  },

  getters: {

  },

  mutations: {

    UPDATE_ORDERS (state, payload) {
      state.orders = [ ...state.orders, ...payload ];
    },

    UPDATE_LAST_INDEX (state, payload) {
      state.last_index = payload;
    },

    RESET_ORDERS (state) {
      state.orders = [];
      state.last_index = 0;
      state.can_load_more = true;
    },

    SET_CAN_LOAD_MORE (state, payload) {
      state.can_load_more = payload;
    },

    SET_CURRENT_ORDER (state, payload) {
      state.current_order = payload;
    },

    UPDATE_FULFILLMENT (state, {order, fulfillment}) {
      let idx = _.findIndex(state.orders, (x) => x.id === order.id);
      if (idx < 0) return;
      
      state.orders[idx].order_fulfillment_id = fulfillment.id;
      state.orders[idx].awb = fulfillment.awb;
      state.orders[idx].courier_name = fulfillment.courier_name;
      state.orders[idx].tracking_url = fulfillment.tracking_url;
    },

    UPDATE_ORDER (state, order) {
      let idx = state.orders.findIndex((x) => x.id === order.id);
      if (idx < 0) {
        state.orders = [ order, ...state.orders ];
      } else {
        state.orders[idx] = order;
      }
    },
  },

  state: {
    orders: [],
    last_index: 0,
    can_load_more: true,
    current_order: {}
  }
}
